<div class="login-page screen06">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="logo">
                    <a href="/converter"><img src="assets/images/logo.png" alt=""></a>
                </div>
            </div>
             <div class="col-lg-6 col-md-12">
                <div class="form-left">
                    <h1 class="text-dark">Create new account</h1>
                    <form action="" class="row g-4 align-items-center mt-3">
                        <div class="col-12">
                            <div class="input-group">
                                <div class="input-group-text">
                                    <i class="bi bi-person-fill">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                            <path
                                                d="M13.8555 16.6251H5.14714C4.05407 16.6251 3.16797 15.739 3.16797 14.6459C3.16797 11.4153 7.91797 11.4793 9.5013 11.4793C11.0846 11.4793 15.8346 11.4153 15.8346 14.6459C15.8346 15.739 14.9485 16.6251 13.8555 16.6251Z"
                                                stroke="#D2D2D2"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M9.5013 8.70833C11.2502 8.70833 12.668 7.29057 12.668 5.54167C12.668 3.79276 11.2502 2.375 9.5013 2.375C7.7524 2.375 6.33464 3.79276 6.33464 5.54167C6.33464 7.29057 7.7524 8.70833 9.5013 8.70833Z"
                                                stroke="#D2D2D2"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </i>
                                </div>
                                <input maxlength="30" type="text" class="form-control" placeholder="Email" />
                            </div>
                        </div>

                        <div class="col-12">
                          <div class="input-group">
                                <div class="input-group-text">
                                    <i class="bi bi-person-fill">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                            <path
                                                d="M13.8555 16.6251H5.14714C4.05407 16.6251 3.16797 15.739 3.16797 14.6459C3.16797 11.4153 7.91797 11.4793 9.5013 11.4793C11.0846 11.4793 15.8346 11.4153 15.8346 14.6459C15.8346 15.739 14.9485 16.6251 13.8555 16.6251Z"
                                                stroke="#D2D2D2"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M9.5013 8.70833C11.2502 8.70833 12.668 7.29057 12.668 5.54167C12.668 3.79276 11.2502 2.375 9.5013 2.375C7.7524 2.375 6.33464 3.79276 6.33464 5.54167C6.33464 7.29057 7.7524 8.70833 9.5013 8.70833Z"
                                                stroke="#D2D2D2"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </i>
                                </div>
                                <input maxlength="30" type="text" class="form-control" placeholder="Name" />
                            </div>
                        </div>



                        <div class="col-12">
                            <div class="input-group">
                                <div class="input-group-text">
                                    <i class="bi bi-lock-fill">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path
                                                d="M13.3346 5.83333C13.3346 3.99238 11.8423 2.5 10.0013 2.5C8.16035 2.5 6.66797 3.99238 6.66797 5.83333V8.69154M6.66797 8.69154C4.81584 9.24601 4.16797 10.5087 4.16797 12.9167C4.16797 16.4216 5.54052 17.5 10.0013 17.5C14.4621 17.5 15.8346 16.4216 15.8346 12.9167C15.8346 10.5087 15.1868 9.24601 13.3346 8.69154C12.4909 8.43896 11.3974 8.33333 10.0013 8.33333C8.60524 8.33333 7.51166 8.43896 6.66797 8.69154Z"
                                                stroke="#D2D2D2"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </i>
                                </div>

                                <input id="password-field" maxlength="30" type="text" class="form-control" placeholder=" Password" />
       
                            </div>
                        </div>

                        <div class="col-sm-6 mt-5">
                            <button type="submit" class="btn btn-primary rounded-pill text-uppercase ps-5 pe-3">
                                Sign up
                                <i class="fas fa-arrow-right ms-3"></i>
                            </button>
                        </div>

                        <div class="col-12 account-txt">
                            <p>Already member? <a href="/login">Log in</a></p> 
                        </div>
                    </form>

                </div>
            </div>
             <div class="col-md-6 pe-0 d-none d-md-none">

            </div>
        </div>
    </div>
</div>